/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
// import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')

const KEY_LOGINUSER = 'LOGINUSER'
export interface ExcelDownloadState {
  errorMessage: string|null;
  accessToken: string|null;
  username: string|null;
  displayName: string|null;
  currentRoles: Array<string>;
  [key: string]: any;
}

const ExcelDownload = defineModule({
  state: (): ExcelDownloadState => {
    return {
      errorMessage: null,
      accessToken: Lib.Session.value(),
      username: null,
      displayName: null,
      currentRoles: []
    }
  },
  getters: {
    isLoggedIn: (...args): boolean => {
      const { state } = loginGetterContext(args)
      return state.accessToken !== null
    }
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    },
    SET_ACCESS_TOKEN (state, token: string) {
      state.accessToken = token
      state.errorMessage = null
      Lib.Session.login(token)
    },
    LOGOUT (state) {
      state.accessToken = null
      state.username = null
      state.displayName = null
      state.currentRoles = []
      Lib.Session.remove(KEY_LOGINUSER)
      Lib.Session.logout()
    }
  },
  actions: {
    async download(context, targetMonth): Promise<any> {
      const { rootState } = moduleActionContext(context, ExcelDownload)
      var numberTargetMonth = parseInt(targetMonth.replace('-', ''))
      const retval = await Lib.Ajax.getDownloadHandleError('/api/ExportTimesheet/excel/' + numberTargetMonth, "Failed to download Timesheets", {}, rootState.Login.accessToken, {}, 'KoosExportTimesheets' +  targetMonth + '.xlsx')
      return retval
    },
    async downloadVacation(context, targetMonth): Promise<any> {
      const { rootState } = moduleActionContext(context, ExcelDownload)
      var numberTargetMonth = parseInt(targetMonth.replace('-', ''))
      const retval = await Lib.Ajax.getDownloadHandleError('/api/ExportTimesheet/vacationstatusexcel/' + numberTargetMonth, "Failed to download Timesheets", {}, rootState.Login.accessToken, {}, 'KoosExportVacation' +  targetMonth + '.xlsx')
      return retval
    },
    async downloadProject(context,payload: {targetMonth: string, projectId: string}): Promise<any> {
      const { rootState } = moduleActionContext(context, ExcelDownload)
      var numberTargetMonth = parseInt(payload.targetMonth.replace('-', ''))
      const retval = await Lib.Ajax.getDownloadHandleError('/api/ProjectReport/byProject/' + payload.projectId + '/' + numberTargetMonth, "Failed to download Timesheets", {}, rootState.Login.accessToken, {}, 'KoosExportProject' +  payload.targetMonth + '.xlsx')
      return retval
    }
  },
  namespaced: true
})

export default ExcelDownload
const loginGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, ExcelDownload)

















